.root {
  background: var(--color-surface);
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 4px;
  height: 100%;
  padding: 12px;
  transition: width 0.2s ease;
  width: 224px;
}

.rootCollapsed {
  background: var(--color-surface);
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 4px;
  height: 100%;
  padding: 12px;
  transition: width 0.2s ease;
  width: 60px;
}

.logo {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 16px 4px 24px;
}

.logoImg {
  height: auto;
  max-height: 128px;
  object-fit: contain;
  width: 100%;
}

.rootCollapsed .logo {
  padding: 12px 0;
}

.nav {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}

.collapsedItem {
  justify-content: center;
  padding: 10px;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 8px;
}

.group-label {
  align-items: center;
  color: var(--color-muted-foreground);
  display: flex;
  gap: 6px;
  padding: 4px 8px 2px;
  text-transform: uppercase;
}

.child-item {
  padding-left: 28px;
}

.footer {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}


/* --- User section (mobile only) --- */

.userSection {
  align-items: center;
  border-top: 1px solid var(--color-border);
  display: none;
  gap: 8px;
  justify-content: space-between;
  padding: 12px 4px 0;
}

.userInfo {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.userDetails {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.userEmail {
  color: var(--color-muted-foreground);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


@media (max-width: 768px) {
  .root,
  .rootCollapsed {
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.15);
    height: 100%;
    position: fixed;
    top: 0;
    transition: left 0.25s ease;
    width: 280px;
    z-index: 50;
  }

  .root {
    left: 0;
  }

  .rootCollapsed {
    left: -280px;
  }

  .footer {
    display: none;
  }

  .userSection {
    display: flex;
  }
}
